<template>
  <div
    v-if="display"
    id="overlay"
    class="security"
  >
    <form>
      <p v-html="$t('pages.memorial.lock_intro')" />
      <b-input-group>
        <b-form-input v-model="password" type="password" />
        <b-input-group-append>
          <b-btn
            variant="primary"
            type="submit"
            @click.prevent="checkPassword()"
          >
            {{ $t('actions.unlock') }}
          </b-btn>
        </b-input-group-append>
      </b-input-group>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'SecurityOverlayComponent',
    props: {
      memorial: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        name: 'memorial',
        password: '',
        display: false,
      };
    },
    mounted() {
      const goodPassword = this.memorial.private_password === this.get().password;
      if (!this.oauth() && !!this.memorial.private_password && !goodPassword && this.memorial.enabled) {
        this.display = true;
      }
      this.$bus.$emit('t-event.memorial.locked', this.display);
    },
    methods: {
      checkPassword() {
        this.output = this.password;
        if (this.output === this.get().memorial.private_password) {
          this.set({ password: this.output });
          this.display = false;
          this.$bus.$emit('t-event.memorial.locked', this.display);
        } else {
          this.$notify({
            title: this.$t(`flashes.${this.name}.unlock_title`),
            text: this.$t(`flashes.${this.name}.unlock_error`),
            type: 'error',
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  #overlay {
    background: rgba($black, .8);
    position: fixed;
    z-index: 9999;
    left: 0;
    top: $nav-height;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;

    form {
      margin: auto;

      p {
        color: $white;
      }
    }
  }

  @include editable-max-width(767px) {
    #overlay {
      top: $nav-height;

      form {
        padding: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SecurityOverlay.vue